import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const Transactions = () => {
  const [transactions, setTransactions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    fetchTransactions();
  }, []);

  const fetchTransactions = async () => {
    try {
      const [depositRes, withdrawRes, bonusRes] = await Promise.all([
        fetch("https://api.backofficemain.com/get_deposit.php"),
        fetch("https://api.backofficemain.com/get_withdraw.php"),
        fetch("https://api.backofficemain.com/get_bonusx.php"),
      ]);

      const depositData = await depositRes.json();
      const withdrawData = await withdrawRes.json();
      const bonusData = await bonusRes.json();

      const deposits =
        depositData.data?.map((item) => ({
          id: `D${item.id}`,
          type: "Deposit",
          user: item.user_username,
          staff: item.staff_username,
          amount: `+$${parseFloat(item.nominal).toFixed(2)}`,
          status: "Approved",
          date: item.created_at,
        })) || [];

      const withdraws =
        withdrawData.data?.map((item) => ({
          id: `W${item.id}`,
          type: "Withdraw",
          user: item.user_username,
          staff: item.staff_username,
          amount: `-$${parseFloat(item.amount).toFixed(2)}`,
          status: item.is_approved === "1" ? "Approved" : "Pending",
          date: item.created_at,
        })) || [];

      const bonuses =
        bonusData.data?.map((item) => ({
          id: `B${item.id}`,
          type: "Bonus",
          user: item.user_username,
          staff: item.staff_username,
          amount: `+$${parseFloat(item.nominal).toFixed(2)}`,
          status: "Approved",
          date: item.created_at,
        })) || [];

      const allTransactions = [...deposits, ...withdraws, ...bonuses].sort(
        (a, b) => new Date(b.date) - new Date(a.date)
      );

      setTransactions(allTransactions);
    } catch (err) {
      console.error("Error fetching transactions:", err);
    }
  };

  // ✅ Filter transaksi berdasarkan pencarian dan tanggal
  const filteredTransactions = transactions.filter((tx) => {
    const matchSearch =
      tx.user.toLowerCase().includes(searchTerm.toLowerCase()) ||
      tx.staff.toLowerCase().includes(searchTerm.toLowerCase()) ||
      tx.type.toLowerCase().includes(searchTerm.toLowerCase());

    const txDate = new Date(tx.date);
    const matchDate =
      (!startDate || txDate >= new Date(startDate)) &&
      (!endDate || txDate <= new Date(endDate));

    return matchSearch && matchDate;
  });

  return (
    <div className="container-fluid py-4 bg-light min-vh-100">
      <div className="card shadow-sm border-0 rounded-4">
        <div className="card-header bg-white border-0 py-3 px-4 d-flex flex-wrap justify-content-between align-items-center">
          <h4 className="fw-semibold text-primary mb-2 mb-md-0">
            📊 Transactions Overview
          </h4>
          <div className="d-flex flex-wrap gap-2">
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Search by user, staff, or type..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ width: "240px" }}
            />
            <input
              type="date"
              className="form-control form-control-sm"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
            <input
              type="date"
              className="form-control form-control-sm"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
            <button
              className="btn btn-outline-secondary btn-sm"
              onClick={() => {
                setStartDate("");
                setEndDate("");
                setSearchTerm("");
              }}
            >
              Reset
            </button>
          </div>
        </div>

        <div className="card-body p-4">
          <div className="table-responsive">
            <table className="table table-hover align-middle">
              <thead className="table-light">
                <tr>
                  <th>ID</th>
                  <th>Type</th>
                  <th>User</th>
                  <th>Staff</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {filteredTransactions.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="text-center text-muted py-4">
                      No transactions found.
                    </td>
                  </tr>
                ) : (
                  filteredTransactions.map((tx) => (
                    <tr key={tx.id}>
                      <td className="text-muted small">{tx.id}</td>
                      <td>
                        <span
                          className={`badge ${
                            tx.type === "Deposit"
                              ? "bg-success"
                              : tx.type === "Withdraw"
                              ? "bg-danger"
                              : "bg-info"
                          }`}
                        >
                          {tx.type}
                        </span>
                      </td>
                      <td>{tx.user}</td>
                      <td>{tx.staff}</td>
                      <td className="fw-semibold">{tx.amount}</td>
                      <td>
                        <span
                          className={`badge rounded-pill ${
                            tx.status === "Approved"
                              ? "bg-success-subtle text-success border border-success-subtle"
                              : "bg-warning-subtle text-warning border border-warning-subtle"
                          } px-3 py-2`}
                        >
                          {tx.status}
                        </span>
                      </td>
                      <td>{new Date(tx.date).toLocaleString()}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Transactions;
